import { ApiClient } from "../common/apiClient";
import { ApiResult } from "../common/apiResult";
import { getRequestOptions } from "../common/helpers";

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}/api/users`;

export interface GetUsageResponse {
    maxUsage: number,
    used: number,
    maxApiRequests: number,
    usedApiRequests: number,
    plan: Plan,
    resetsAfter: number
}

export enum Plan {
  Free = "Free",
  Basic = "Basic",
  Pro = "Pro",
  Developer = "Developer"
}

export const UserService = {
  getUsage: async (): Promise<ApiResult<GetUsageResponse>> => {
    const options = getRequestOptions();
    try {
      const result = await ApiClient.get<GetUsageResponse>(`${API_BASE}/usage`, options);
      return { data: result };
    } catch (err: any) {
      return {
        error: {
          message: err?.message || "Failed to get usage",
        },
      };
    }
  },
};